import React from 'react';
import { motion } from 'framer-motion';
import { ScrollReveal } from './ui/ScrollReveal';
export function ShowcaseGallery() {
  return <section className="py-24 bg-brand-green-deep overflow-hidden" data-id="element-407">
      <div className="max-w-[1400px] mx-auto px-6" data-id="element-408">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6" data-id="element-409">
          {/* Large Featured Image */}
          <div className="md:col-span-8 h-[600px] relative rounded-2xl overflow-hidden group" data-id="element-410">
            <ScrollReveal delay={0.1} className="w-full h-full" data-id="element-411">
              <motion.img whileHover={{
              scale: 1.05
            }} transition={{
              duration: 0.8,
              ease: 'easeOut'
            }} src="https://cdn.magicpatterns.com/uploads/3b62EKAAjmaPYQxrkuwQqy/estategreen.png" alt="Estate Green Showcase" className="w-full h-full object-cover" data-id="element-412" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent pointer-events-none" data-id="element-413" />
              <div className="absolute bottom-8 left-8 right-8 pointer-events-none" data-id="element-414">
                <span className="text-brand-gold text-xs font-bold tracking-[0.2em] uppercase mb-2 block" data-id="element-415">
                  Featured Project
                </span>
                <h3 className="text-3xl md:text-4xl font-heading text-brand-cream-light" data-id="element-416">
                  The Estate Collection
                </h3>
              </div>
            </ScrollReveal>
          </div>

          {/* Small Top Right */}
          <div className="md:col-span-4 h-[600px] flex flex-col gap-6" data-id="element-417">
            <div className="flex-1 relative rounded-2xl overflow-hidden group" data-id="element-418">
              <ScrollReveal delay={0.2} className="w-full h-full" data-id="element-419">
                <motion.img whileHover={{
                scale: 1.05
              }} transition={{
                duration: 0.8,
                ease: 'easeOut'
              }} src="https://cdn.magicpatterns.com/uploads/tvAkCsifm3oKpj9V73sDzg/sunet_green.png" alt="Sunset Green Showcase" className="w-full h-full object-cover" data-id="element-420" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent pointer-events-none" data-id="element-421" />
                <div className="absolute bottom-6 left-6 pointer-events-none" data-id="element-422">
                  <h3 className="text-xl font-heading text-brand-cream-light" data-id="element-423">
                    Coastal Concepts
                  </h3>
                </div>
              </ScrollReveal>
            </div>

            {/* Small Bottom Right */}
            <div className="flex-1 relative rounded-2xl overflow-hidden group" data-id="element-424">
              <ScrollReveal delay={0.3} className="w-full h-full" data-id="element-425">
                <motion.img whileHover={{
                scale: 1.05
              }} transition={{
                duration: 0.8,
                ease: 'easeOut'
              }} src="https://cdn.magicpatterns.com/uploads/o2kbb1M8SM3uegyLFntqUo/wedding_golf.png" alt="Wedding Green Showcase" className="w-full h-full object-cover" data-id="element-426" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent pointer-events-none" data-id="element-427" />
                <div className="absolute bottom-6 left-6 pointer-events-none" data-id="element-428">
                  <h3 className="text-xl font-heading text-brand-cream-light" data-id="element-429">
                    Event Activations
                  </h3>
                </div>
              </ScrollReveal>
            </div>
          </div>
        </div>
      </div>
    </section>;
}